import { render, staticRenderFns } from "./Ouvidoria.vue?vue&type=template&id=06d2d9ff&scoped=true"
import script from "./Ouvidoria.vue?vue&type=script&lang=js"
export * from "./Ouvidoria.vue?vue&type=script&lang=js"
import style0 from "./Ouvidoria.vue?vue&type=style&index=0&id=06d2d9ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2d9ff",
  null
  
)

export default component.exports